<template>
  <div :class="[containerDefaultClass, containerClass, {inactive: disabled}]">
    <button :id="buttonId || undefined" :class="buttonClass" :disabled="disabled" @click.prevent="handleClick">
      <slot name="default"></slot>
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  buttonId: {
    type: String,
    default: '',
  },
  containerDefaultClass: {
    type: [String, Object, Array],
    default: 'outline_fancy_btn',
  },
  containerClass: {
    type: [String, Object, Array],
    default: '',
  },
  buttonClass: {
    type: [String, Object, Array],
    default: 'fancy_btn',
  },
});

const emit = defineEmits(['click:button']);

const handleClick = (event) => {
  if (props.disabled) return;
  emit('click:button', event);
};
</script>
